<template>
    <div
        style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100vw; flex-direction: column;">
        <div class="container">
            <div style="font-size: 0.15rem;">修改密码</div>
            <a-alert message="系统提示：密码超过3个月未进行修改，需要进行修改！" type="info" show-icon style="margin-top: 20px;" />
             <a-spin :spinning="spinning">
            <a-form-model ref="formRef" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" :model="form"
                :rules="rules">
                <!-- <a-form-model-item label="旧密码" prop="oldPassword">
                    <a-input-password v-model="form.oldPassword"></a-input-password>
                </a-form-model-item> -->
                <a-form-model-item label="新密码" prop="newPassword" style="margin-top: 20px;">
                    <a-input-password v-model="form.newPassword"></a-input-password>
                </a-form-model-item>
                <a-form-model-item label="确认密码" prop="confirmPassword">
                    <a-input-password v-model="form.confirmPassword"></a-input-password>
                </a-form-model-item>
                <a-form-model-item label="图形验证码" prop="imageCode">
                    <a-input v-model="form.imageCode">
                        <template slot="addonAfter">
                            <img @click="getImageCode" style="width: 5.3vw; height: 4vh;"
                                :src="'https://business-api.admot.cn/login/getImageCode?time='+time" alt="" />
                        </template>
                    </a-input>
                </a-form-model-item>
                <a-form-model-item label="手机验证码" prop="smsCode">
                    <a-input v-model="form.smsCode">
                        <template slot="addonAfter">
                            <a-button type="primary" class="getCode" :disabled="getSmscodeFlag" @click="getSmsCode">{{
                                smsCount }}{{ getSmscodeFlag ? '秒' : '' }}</a-button>
                        </template>
                    </a-input>
                </a-form-model-item>
                <div style="display: flex; justify-content: space-around;">
                    <a-button @click="back" type="info">返回登录</a-button>
                    <a-button @click="submit" type="primary">确认修改</a-button>
                </div>
            </a-form-model>
             </a-spin>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                time: new Date().getTime(),
                form: {
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: '',
                    imageCode: '',
                    smsCode: '',
                },
                userPhone: '',
                getSmscodeFlag: false,
                smsCount: '获取验证码',
                spinning:false,
                rules: {
                    // oldPassword: [
                    //     { required: true, message: '请输入旧密码', trigger: 'blur' },
                    // ],
                    newPassword: [
                        {
                            required: true, validator: ( rules,value, callback) => {
                                if (!value) {
                                    return callback(new Error('密码不能为空'));
                                }
                                if (value.length < 12 || value.length > 20) {
                                    return callback(new Error('密码长度需为12-20位，推荐16位。'))
                                }
                                const regex = /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])|(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z0-9])|(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9])).{12,20}$/;
                                if (!regex.test(value)) {
                                    return callback(new Error('新密码需至少包含大写、小写、数字、特殊字符中的3类，且无3个连续或重复字符'))
                                }
                                let isInvalid = false
                                for (let i = 0; i < value.length - 2; i++) {
                                    const c1 = value.charCodeAt(i)
                                    const c2 = value.charCodeAt(i + 1)
                                    const c3 = value.charCodeAt(i + 2)
                                    if (
                                        (c2 == c1 + 1 && c3 == c2 + 1)
                                        || (c2 == c1 - 1 && c3 == c2 - 1)
                                        || (c2 == c1 && c3 == c2)
                                    ) {
                                        isInvalid = true
                                    }
                                }
                                if (isInvalid) {
                                    return callback(new Error('密码不能有连续的字符'))
                                }
                                callback();
                            }, trigger: 'blur'
                        },
                    ],
                    confirmPassword: [
                        {
                            required: true, validator: (rules, value, callback) => {
                                if (!value || value == '') {
                                    return callback(new Error('请输入确认密码'));
                                }
                                if (value != this.form.newPassword) {
                                    return callback(new Error('两次密码不一致，请重新输入'));
                                }
                                callback();
                            }, trigger: 'blur'
                        }
                    ],
                    imageCode: [
                        { required: true, message: '请输入图形验证码', trigger: 'blur' },
                    ],
                    smsCode: [
                        { required: true, message: '请输入手机验证码', trigger: 'blur' },
                    ],
                }
            }
        },
        mounted() {
            this.userPhone = this.$store.getters.userInfo.phone
        },
        methods: {
            getImageCode() {
                this.time = new Date().getTime();
            },
            getSmsCode() {
                const _this = this;
                this.$refs.formRef.validateField('imageCode' , (val)=>{
                    if (val =="请输入图形验证码") {
                        return 
                    }
                _this.$http.getSmsCode(`/login/smsSendCodePC?phone=${_this.userPhone}&imgCode=${_this.form.imageCode}&type=2`).then(res => {
                    if (res.rescode == 200) {
                        _this.getSmscodeFlag = true;
                        _this.smsCount = 60;
                        let timer = setInterval(() => {
                            _this.smsCount -= 1;
                            if (_this.smsCount == 0) {
                                clearInterval(timer);
                                _this.smsCount = '获取验证码';
                                _this.getSmscodeFlag = false;
                            }
                        }, 1000);
                    }
                })
                })

            },
            submit(){
                const _this = this;
                this.$refs.formRef.validate((valid) => {
                    if (valid) { 
                        let params = {
                            phone: _this.userPhone,
                            code: _this.form.smsCode,
                            passWord: _this.form.newPassword,
                        };
                        	_this.$http
						.post('/usertoken/resetPassword', params)
						.then(res => {
							if (res.rescode == 200) {
								_this.spinning = false;
                                localStorage.setItem("updatePwdFlag", "false")
								_this.$message.success('密码修改成功');
								_this.$router.push({ name: 'Login' });
							} else {
								_this.$message.warning(res.msg);
								_this.spinning = false;
							}
						})
						.catch(error => {
							_this.spinning = false;
						});
                    }else {
                        this.spinning = false;
                    }
                })
            },
            back() {
                this.$router.push({ name: 'Login' });
            }
        },
    }
</script>
<style scoped>
    .container {
        width: 35vw;
        background-color: white;
        padding: 25px;
    }
</style>